// Tuning knobs — all subject to v0 testing.
// These are the only source of truth for magic numbers in the system.
/** Boundary between daily and short-gap engagement (days) */
export const SHORT_GAP_THRESHOLD = 3;
/** Boundary between short-gap and long-gap engagement (days) */
export const LONG_GAP_THRESHOLD = 14;
/** Score bonus for quick-effort items after a gap */
export const QUICK_WIN_BOOST = 15;
/** Score bonus accumulation for unsurfaced items (temperature units per day) */
export const FRESHNESS_RATE = 0.5;
/** Maximum freshness bonus */
export const FRESHNESS_CAP = 10;
/** Temperature below which items enter fading state */
export const FADE_THRESHOLD = 10;
/** Reheats before cooling→warming phase shift */
export const REHEAT_PHASE_SHIFT_THRESHOLD = 3;
/** How long an overdue warming item takes to cool down (days) */
export const WARMING_EXPIRY_COOLING_DURATION = 30;
/** Default ceiling for items that shift from cooling to warming */
export const PHASE_SHIFT_CEILING = 70;
/** How long a phase-shifted item takes to reach ceiling (days) */
export const PHASE_SHIFT_DURATION = 14;
/** Max temperature a regular reheat restores */
export const REHEAT_TEMPERATURE_CAP = 50;
//# sourceMappingURL=constants.js.map